export default __webpack_public_path__ + "static/media/classic.bb4d0927.png";